import { render } from "./Description.vue?vue&type=template&id=bab84992"
const script = {}

import exportComponent from "/home/cellposition/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__